import { capitalize } from 'lodash'
import type { BackupAuditLog } from '../api/backupApi'
import { formatDate } from '@/utils/timeZoneUtils'
import { useUsersStore } from '@/features/users/store/usersStore'

type MobileBackupLogCardProps = {
  log: BackupAuditLog
}

export default function MobileLogCard({ log }: MobileBackupLogCardProps) {
  const users = useUsersStore((s) => s.users)
  const logUser = users.find((u) => u._id === log.userId)
  const userName =
    log.userId === '000000000000000000000000'
      ? 'System'
      : logUser
        ? logUser.name
        : 'Unknown User'
  return (
    <div
      key={log._id}
      className="rounded-md border bg-white p-4 flex flex-col gap-2 shadow-sm"
    >
      <div className="flex items-center justify-between">
        <span className="font-semibold text-sm text-gray-700">
          {capitalize(log.action)}
        </span>
        <span className="text-xs text-gray-500">
          {formatDate(log.timestamp, 'DD/MM/YYYY hh:mm A')}
        </span>
      </div>
      <div className="grid grid-cols-2 gap-2 text-xs text-gray-600">
        <span>
          <span className="font-medium">Entity:</span> {log.entity}
        </span>
        <span>
          <span className="font-medium">User:</span> {userName}
        </span>
      </div>

      <div className="bg-gray-50 rounded p-2 text-xs overflow-x-auto">
        <pre className="whitespace-pre-wrap break-words max-h-40 overflow-y-auto">
          {JSON.stringify(log.details, null, 2)}
        </pre>
      </div>
    </div>
  )
}
